export function IsFieldEditable(name: string) {
    if (name === 'R' || name === 'D' || name === 'V' || name === 'V130' || name === 'V150' || name === 'Vk' || name === 'Lk1' || name === 'Lk2' || name === 'Lkm')
        return true;
    else return false;

}